import { Component, OnInit } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { ModalProvider } from '@app/components/_shared/modal/modal.component';
import { Breadcrumb } from '@app/models/_base/breadcrumb.model';
import { Footer } from '@app/services/footer.service';
import { LocalisationService } from '@app/services/localisation.service';
import { ResearchService } from '@app/services/research.service';
import { RouteBreadcrumbs } from '@app/services/routeBreadcrumbs.service';
import { UserService } from '@app/services/user.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {
  static route = 'finalise/export';

  locale: any = {};

  emailAddress: string = null;
  public formSubmitted: boolean = false;

  constructor(
    private routeBreadcrumbs: RouteBreadcrumbs,
    private footer: Footer,
    private localisation: LocalisationService,
    private researchService: ResearchService,
    private userService: UserService,
    private modal: ModalProvider
  ) {}

  setFormSubmitted(value) {
    this.formSubmitted = value;
  }

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('ExportComponent');

    let parentLocale = this.localisation.getTranslationsForComponent(
      'FinaliseListComponent'
    ) as any;

    this.routeBreadcrumbs.breadcrumbs.next([
      new Breadcrumb(parentLocale.breadcrumbText, 'finalise'),
      new Breadcrumb(this.locale.breadcrumbText, null)
    ]);

    this.userService.getUser().subscribe(user => {
      this.emailAddress = user.email;
    });

    this.footer.update(null);
  }

  export() {
    this.emailAddress = this.emailAddress.trim();

    if (!this.emailAddress || !this.validateEmail(this.emailAddress)) {
      this.modal.create(this.locale.noEmailModalTitle, this.locale.noEmailModalMessage);
      return;
    }

    this.setFormSubmitted(true);

    this.researchService.exportShortlist(this.emailAddress).subscribe(
      result => {
        this.modal.create(this.locale.successModalTitle, this.locale.successModalMessage);
      },
      error => {},
      () => {
        this.setFormSubmitted(false);
      }
    );
  }

  validateEmail(email: string): boolean {
    var regex = AppConfig.emailRegex;
    return regex.test(email);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/finalise/export/export.component.ts